import { render, staticRenderFns } from "./LoldocupStarTitle.vue?vue&type=template&id=09aa58f3&"
import script from "./LoldocupStarTitle.vue?vue&type=script&lang=js&"
export * from "./LoldocupStarTitle.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupStarTitle.vue?vue&type=style&index=0&id=09aa58f3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports